import Link from "next/link";

export interface BreadcrumbItem {
  name: string;
  href?: string;
}

export default function Breadcrumbs({ trail }: { trail: BreadcrumbItem[] }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="flex items-center gap-1 text-caption flex-wrap"
      style={{ color: "var(--ish-text-faint)" }}
    >
      {trail.map((item, i) => (
        <span key={i} className="flex items-center gap-1">
          {i > 0 && (
            <span aria-hidden="true" className="select-none">
              ›
            </span>
          )}
          {item.href ? (
            <Link
              href={item.href}
              className="hover:text-[var(--ish-dark)] hover:underline transition"
            >
              {item.name}
            </Link>
          ) : (
            <span style={{ color: "var(--ish-dark)" }}>{item.name}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
